import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { updateFilters } from "../redux/activitiesSaga";

export const Dropdown = ({ placeholder, sliceKey }) => {
  const {
    filters: { [sliceKey]: allOptions },
    selectedFilters: { [sliceKey]: selectedOptions }
  } = useSelector((state) => state.activities);

  const dispatch = useDispatch();

  const updateLocations = (data) => {
    dispatch(updateFilters({ [sliceKey]: data }));
  };

  return (
    <MultiSelectDropdown
      filterType="Custom Range"
      options={allOptions}
      placeholder={placeholder}
      numberDisplayed={0}
      selectedFilters={selectedOptions}
      enableDefaultSelected={true}
      haveOnSelectChange={false}
      includeSelectAll={true}
      enableOnly={true}
      updateLocations={updateLocations}
    />
  );
};
